<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') || '平台id/平台名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { menuType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="175px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_platformId') || '平台id'">
              <el-input
                v-model.trim="form.platformId"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_platformName') || '平台名称'">
              <el-input
                v-model.trim="form.platformName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_platformType') || '平台类型'">
              <el-select
                v-model="form.platformType"
                clearable
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width: 100%"
              >
                <el-option
                  v-for="item in platformTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="createStartTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="createEndTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyStartTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyEndTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      platformTypeOptions: [
        { label: '电商平台', value: 'E' },
        { label: '仓库', value: 'W' },
      ],
      //创建日期限制
      createStartTimePicker: this.createEndTime(),
      createEndTimePicker: this.createStartTime(),
      //修改日期限制
      modifyStartTimePicker: this.modifyEndTime(),
      modifyEndTimePicker: this.modifyStartTime(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 创建日期限制
    createEndTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createEndTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createEndTime).getTime() < time.getTime()
          }
        },
      }
    },
    createStartTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createStartTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createStartTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyEndTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyEndTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyEndTime).getTime() < time.getTime()
          }
        },
      }
    },
    modifyStartTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyStartTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyStartTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    orderEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.orderEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    orderStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.orderStartDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
